// -----------------------------------------------------------------------------
// UI theme switcher (temporary, for choosing a direction).
// Each theme sets: Vuetify colours, top bar / sidebar colours (via the existing
// store), the icon library for the shell, and a data-ui-theme attribute that
// switches the CSS variables in src/scss/vuetify/_theme.scss.
// Once a theme is chosen, keep its values and delete the switcher.
// -----------------------------------------------------------------------------

export const UI_THEME_STORAGE_KEY = "ncp-ui-theme";
export const DEFAULT_UI_THEME = "clean";

export const UI_THEMES = {
  clean: {
    label: "Clean Commerce",
    description: "Shopify-admin look · Lucide icons",
    iconSet: "lucide",
    navbarColor: "#1A1A1A",
    sidebarColor: "white",
    colors: {
      primary: "#303030",
      secondary: "#616161",
      info: "#005BD3",
      success: "#29845A",
      warning: "#B28400",
      error: "#C70A24",
      accent: "#005BD3",
      default: "#303030",
    },
  },
  ledger: {
    label: "Ledger",
    description: "Accounting look · Tabler icons",
    iconSet: "tabler",
    navbarColor: "white",
    sidebarColor: "#0F1F33",
    colors: {
      primary: "#0B6BCB",
      secondary: "#4B5563",
      info: "#0B6BCB",
      success: "#18794E",
      warning: "#B54708",
      error: "#B42318",
      accent: "#0B6BCB",
      default: "#1F2A37",
    },
  },
  brand: {
    label: "Partify Brand",
    description: "Partify blue · Phosphor icons",
    iconSet: "phosphor",
    navbarColor: "#1F5BC0",
    sidebarColor: "white",
    colors: {
      primary: "#1F5BC0",
      secondary: "#475569",
      info: "#1F5BC0",
      success: "#15803D",
      warning: "#B45309",
      error: "#B91C1C",
      accent: "#C2560C",
      default: "#1E293B",
    },
  },
};

export function getSavedUiTheme() {
  try {
    const saved = localStorage.getItem(UI_THEME_STORAGE_KEY);
    return UI_THEMES[saved] ? saved : DEFAULT_UI_THEME;
  } catch (e) {
    return DEFAULT_UI_THEME;
  }
}

/**
 * Apply a theme at runtime.
 * @param {Object} vuetify  the Vuetify instance (this.$vuetify)
 * @param {Object} store    the Vuex store
 * @param {String} key      clean | ledger | brand
 */
export function applyUiTheme(vuetify, store, key) {
  const name = UI_THEMES[key] ? key : DEFAULT_UI_THEME;
  const theme = UI_THEMES[name];

  document.documentElement.setAttribute("data-ui-theme", name);

  Object.keys(theme.colors).forEach((c) => {
    vuetify.theme.themes.light[c] = theme.colors[c];
  });

  store.commit("SET_NAVBAR_COLOR", theme.navbarColor);
  store.commit("SET_SIDEBAR_COLOR", theme.sidebarColor);
  store.commit("SET_UI_THEME", name);

  try {
    localStorage.setItem(UI_THEME_STORAGE_KEY, name);
  } catch (e) {
    // private mode etc. — theme still applies for this session
  }
}
